<template>
  <div class="ficha-mapa ficha-propiedades-suelo">
    <div class="encabezado">Propiedades de suelo</div>
    <div class="contenedor">
      <div class="col">
        <div class="ficha">
          <div class="ficha-foto">
            <img
              src="@/assets/fichas-diagnostico/propiedades-suelo/1-Medicion en campo.png"
              class="foto"
              alt=""
            />
            <div class="degradado"></div>
            <div class="cuadro-contraste"></div>
            <p class="pie-foto">Medición en campo</p>
          </div>
          <div class="ficha-titulo">
            <h4>pH del suelo</h4>
          </div>
          <div class="ficha-cuerpo">
            <p>
              Los suelos del área son suelos alcalinos, salinos y con un alto
              riesgo de erosión, de acuerdo con las propiedades de la capa u
              horizonte superficial.
              <b>Los materiales son en su mayoría alcalinos con pH >7</b>,
              aunque el 46.5% de la superficie (5,506.93 ha) presentan pH de
              fuerte (8.6) a muy fuertemente alcalinos, es decir, con pH >10.
              Son principalmente suelos salinos (>4dSm-1), pero los
              extremadamente salinos cubren una superficie de 2,332 ha. Aunado a
              lo anterior,
              <b
                >el área presenta un alto a muy alto grado de riesgo de
                erosión</b
              >
              en 6,659.70 ha.
            </p>
          </div>
        </div>
      </div>
      <div class="ficha-separador"></div>
      <div class="col">
        <div class="ficha">
          <div class="ficha-foto">
            <img
              src="@/assets/fichas-diagnostico/propiedades-suelo/2-Desecamiento de sedimientos.png"
              class="foto"
              alt=""
            />
            <div class="degradado"></div>
            <div class="cuadro-contraste"></div>
            <p class="pie-foto">Desecamiento de sedimentos</p>
          </div>
          <div class="ficha-titulo">
            <h4>Salinidad superficial</h4>
          </div>
          <div class="ficha-cuerpo">
            <p>
              El origen de la extrema salinidad en la Zona Federal Lago de
              Texcoco se debe, por una parte, a procesos de intemperismo químico
              de las rocas volcánicas y a los flujos de agua que han concentrado
              a estos iones en la parte más baja de la cuenca (SRH, 1971;
              Cruickshank, 2007).
            </p>
            <p>
              Por otra parte,
              <b
                >el constante desecamiento de los sedimentos lacustres ha
                incrementado la concentración iónica, la salinidad y el pH del
                suelo.
              </b>
              El sitio presenta procesos de salinización, sodificación,
              hundimientos, desecación, erosión eólica y calidad de los suelos,
              condiciones que ponen en riesgo cualquier proyecto de
              infraestructura que se pretenda realizar en la zona (Conacyt,
              Oficio/A0000/301/2021).
            </p>
          </div>
        </div>
      </div>
      <div class="ficha-separador"></div>
      <div class="col">
        <div class="ficha">
          <div class="ficha-foto">
            <img
              src="@/assets/fichas-diagnostico/propiedades-suelo/3-Material particulado.png"
              class="foto"
              alt=""
            />
            <div class="degradado"></div>
            <div class="cuadro-contraste"></div>
            <p class="pie-foto">Material particulado</p>
          </div>
          <div class="ficha-titulo">
            <h4>Riesgo de erosión eólica</h4>
          </div>
          <div class="ficha-cuerpo">
            <p>
              El exvaso de Texcoco ha sido una fuente de material particulado
              desde que las obras de drenaje de la cuenca de México llevaron a
              desecar el antiguo lago de Texcoco (Jazcilevich et al., 2015). Los
              trabajos de Díaz-Nigenda et al. (2010) muestran un episodio de
              emisión por erosión en la zona del exvaso, y lo que ocurre cuando
              estas emisiones son mitigadas al humedecer el suelo. Esto indica
              que el
              <b
                >mitigar las emisiones provenientes de la ZFLT reducirá
                sustancialmente los días con concentraciones extraordinarias de
                material particulado,
              </b>
              aunque no son las únicas fuentes (Jazcilevich et al., 2015).
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PropiedadesDeSuelo",
};
</script>
